import { setStoredChatId } from "./cloud-storage"
import { resolveTelegramRouteContext } from "./resolve-telegram-route-context"
import { RouterContext, TelegramContext } from "./router-context"

export const getRouterContext = async () => {
  const { chatId, shareToken, startParamChatId } = await resolveTelegramRouteContext()

  if (!chatId && !shareToken) {
    return RouterContext
  }

  // Save chatId to CloudStorage for future sessions
  if (startParamChatId) {
    setStoredChatId(startParamChatId).catch((error: unknown) => {
      console.warn("[RouterContext] Failed to save chatId to CloudStorage:", error)
    })
  }

  RouterContext.set(TelegramContext, { chatId, shareToken })

  return RouterContext
}
